import { memo } from 'react';

function SpecialInstructionMarker(props) {
  return (
    <svg width={props.dimension} height={props.dimension} viewBox="0 0 23 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <desc>Created with Sketch.</desc>
      <defs>
        <radialGradient cx="50%" cy="0%" fx="50%" fy="0%" r="100%" id="radialGradient-1">
          <stop stopColor={props.gradientPrimaryColor} offset="0%" />
          <stop stopColor={props.gradientSecondaryColor} offset="100%" />
        </radialGradient>
      </defs>
      <g id="Map-interactions" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Group-30" transform="translate(1.000000, 1.000000)" fillRule="nonzero">
          <circle id="Oval" stroke="#090F1E"  fill={props.backgroundColor ||"url(#radialGradient-1)"} cx="10.5" cy="10.5" r="10.5" />
          <g id="icons8-comments" transform="translate(6.000000, 6.000000)" fill="#000000">
            <path d="M0.953311,1 C0.432804905,1 0.000930047619,1.43187486 0.000930047619,1.95238095 L0.000930047619,7.66666667 C0.000930047619,8.18717286 0.432804905,8.61904762 0.953311,8.61904762 L7.61997762,8.61904762 L9.52473952,10.5238095 L9.51915905,1.9514509 C9.51915952,1.43094481 9.08670905,1 8.5667781,1 L0.953311,1 Z M0.953311,1.95238095 L8.5667781,1.95238095 L8.57049857,8.22284238 L8.01432286,7.66666667 L0.953311,7.66666667 L0.953311,1.95238095 Z M2.38095238,3.38095238 L2.38095238,4.33333333 L7.14285714,4.33333333 L7.14285714,3.38095238 L2.38095238,3.38095238 Z M2.38095238,5.28571429 L2.38095238,6.23809524 L5.71428571,6.23809524 L5.71428571,5.28571429 L2.38095238,5.28571429 Z" id="Shape" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default memo(SpecialInstructionMarker);